








































































































































import BaseComponent from '@/components/base-component.vue';
import CollapsibleCard from '@/components/UI/collapsible-card.vue';
import InputMoney from '@/components/UI/input-money.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import { sortKey } from '@/helpers/sort';
import { toNumber } from '@/helpers/toNumber';
import { PrescricaoOpcoesProdutosParmDTO, PrescricaoParmDTO } from '@/interfaces/prescription';
import { ConversaoMedidasDTO, MedidasProdutosEnteralResult, UnidadeMedidaProdCalcParm, UnidadesMedidasProdutosPacienteCalcParm } from '@/interfaces/product';
import { ProdutoOcrResult, TranscricaoOcrResult } from '@/interfaces/transcricao-ocr';
import PrescriptionTemplateModel from '@/models/prescription-template-model';
import * as service from '@/services/prescription';
import { getPatientType } from '@/settings/consts/patient';
import {
  PARAM_UI_DIA_UNIT, PRESCRIPTION_VALIDATION_TYPE_ERROR, PRESCRIPTION_VALIDATION_TYPE_WARNING
} from '@/settings/consts/prescription-params';
import { DEFAULT, MODEL } from '@/settings/consts/prescriptions-types';
import { cloneDeep } from 'lodash';
import { BehaviorSubject, of, timer } from 'rxjs';
import { catchError, debounce, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { TerapiaUsoDTO } from '../../interfaces/therapy';
import ProductChart from './product-chart.vue';
import ProductSplitter from './product-splitter.vue';

@Component({
  components: {
    CollapsibleCard,
    InputMoney,
    ListMessages,
    ProductChart,
    ProductSplitter
  },
})
export default class PrescriptionProductsList extends BaseComponent {
  @Prop()
  public value!: any;
  @Prop()
  public item!: any;
  @Prop()
  public receivedProducts!: any[];
  @Prop()
  public receivedWeight!: any;
  @Prop()
  public receivedCaloricWeight!: any;
  @Prop()
  public receivedInfusionTime!: any;
  @Prop({
    default: () => [],
  })
  public productsToCorrect?: any[];
  @Prop({
    default: null,
  })
  public productToCorrect?: any;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public isPrescricao: boolean;
  @Prop()
  public terapiaUso: TerapiaUsoDTO;
  private terapiaCarregada:boolean = false;
  @Prop()
  private enteralResult: MedidasProdutosEnteralResult;
  @Prop()
  private validarUsoHistorico: boolean;

  @Prop()
  public ocr: TranscricaoOcrResult;
  private ocrLoaded: boolean = false; 

  @Prop()
  public draft: PrescricaoParmDTO;

  public sendedUnits: any[] = [];
  public groupsList: any[] = [];
  public groupsLoading: boolean = false;
  public groupsError: boolean = false;

  private produtosUsoHistConfirmar: Map<number,ConversaoMedidasDTO> = new Map();
  private idsProdutosUsoHistConfirmados: number[] = [];

  @Watch('terapiaUso')
  public onChangeTerapiaUso(): void {
    this.terapiaCarregada = false;
    this.clearProdutosQtde();
    this.loadTerapia();
    this.resetEnteral();
  }

  @Watch('enteralResult')
  public onChangeEnteralResult(result): void {   
    if (result) {
      this.vincularEnteral();
    } else {
      this.descontarEnteral(true);
    }
  }

  @Watch('item.volumeDesejado')
  public onChangeVolumeDesejado(): void {
    this.recalcAllUnits(true);
  }

  @Watch('item.cliente.id')
  public onChangeClient(val): void {
    if (!val) {
      return;
    }
    this.prepareGetGroups();
    this.prepareRecalcAllUnits();
  }

  @Watch('item.unidade.id')
  public onChangeUnitClient(val): void {
    if (!val) {
      return;
    }
    this.prepareGetGroups();
    this.prepareRecalcAllUnits();
  }

  @Watch('item.paciente.id')
  public onChangePaciente(val): void {
    if (!val) {
      return;
    }
    this.prepareGetGroups();
    this.prepareRecalcAllUnits();
  }

  @Watch('item.paciente.completo')
  public onChangePacienteCompleto(completo): void {
    if (!completo) {
      return;
    }
    this.prepareGetGroups();
    this.prepareRecalcAllUnits();
  }
  
  @Watch('item.tipoPaciente')
  public onChangeTipoPaciente(val): void {
    if (!val) {
      return;
    }
    this.prepareGetGroups();
    this.prepareRecalcAllUnits();
  }

  @Watch('item.paciente.peso')
  public onChangePacientePeso(val): void {
    if (!val) {
      return;
    }
    this.prepareGetGroups();
    this.prepareRecalcAllUnits();
  }

  @Watch('item.usoPesoCalorico')
  public onChangeItemUsoPesoCalorico(val): void {
    this.prepareRecalcAllUnits();
  } 
  
  @Watch('item.paciente.pesoCalorico')
  public onChangePacPesoCalorico(val): void {
    this.prepareRecalcAllUnits();
  }

  @Watch('item.peso')
  public onChangePeso(val): void {
    if (!val) {
      return;
    }
    this.prepareRecalcAllUnits();
  }

  @Watch('item.tempoInfusao')
  public onChangeTempoInfusao(val): void {
    if (!val) {
      return;
    }
    this.prepareRecalcAllUnits();
  }

  @Watch('receivedProducts')
  public onChangeProducts(val): void {
    if (!val) {
      return;
    }
    this.prepareGetGroups();
  }

  @Watch('productToCorrect')
  public onChangeProductToCorret(val): void {
    if (!val) {
      return;
    }

    this.scrollToProduct(this.productToCorrect);
  }

  @Watch('ocr')
  public onChangeOcr(ocr: TranscricaoOcrResult): void {    
    if (!ocr || !ocr.idPaciente) {
      return;
    }
    this.ocrLoaded = false;
    
    this.sleepUntil(() => {
      return this.item 
      && this.item.paciente 
      && this.item.paciente.completo 
      && this.groupsList 
      && this.groupsList.length > 0
      && !this.groupsLoading 
      && !this.groupsError;
    }, 180000).then(() => {
      this.loadProdutosOcr(ocr);
      this.ocrLoaded = true;
    });
  }

  @Watch('draft')
  public onChangeDraft(draft: PrescricaoParmDTO) {
    if (!draft == null || !draft.idPaciente || (draft.tipoPrescricao != MODEL && draft.tipoPrescricao != DEFAULT)) {
      return;
    }

    let ocr = new TranscricaoOcrResult();
    ocr.produtos = draft.produtos.map(p => {
      let pOcr = new ProdutoOcrResult();
      pOcr.id = p.idProduto;
      pOcr.idUnidadeMedida = p.idUnidadeMedida;
      pOcr.quantidade = p.valor;
      return pOcr;
    });
    ocr.idPaciente = draft.idPaciente;
    this.onChangeOcr(ocr);
  }

  public productClass(product): any {
    return {
      error: this.isError(product),
      warning: this.isWarning(product),
      disabled: this.productsIsDisabled(product),
    };
  }

  public productsIsDisabled(product): boolean {
    const unitNeedVolumeTotal = () =>
      !product.unidadeMedidasProduto ||
      product.unidadeMedidasProduto.some((unit) => unit.necessitaVolumeFinal);
    const volumeTotalIsEmpty = () => !toNumber(this.item.volumeDesejado);
    return unitNeedVolumeTotal() && volumeTotalIsEmpty();
  }

  private isTherapyNotEditable() {
    return this.terapiaUso && !this.terapiaUso.podeAlterarQuantidades;
  }

  private isTemplate() {
    return this.item && this.item instanceof PrescriptionTemplateModel;
  }

  public isError(product): boolean {
    const foundProduct = this.productsToCorrect.find(
      (item) => item.id === product.id,
    );
    const hasError = !!foundProduct
      ? foundProduct.type === PRESCRIPTION_VALIDATION_TYPE_ERROR
      : false;
    return hasError;
  }

  public isWarning(product): boolean {
    const foundProduct = this.productsToCorrect.find(
      (item) => item.id === product.id,
    );
    const hasWarning = !!foundProduct
      ? foundProduct.type === PRESCRIPTION_VALIDATION_TYPE_WARNING
      : false;
    return hasWarning;
  }

  public scrollToProduct(product): void {
    if (!!this.$refs[product.id] && !!this.$refs[product.id][0]) {
      const productWrapElement = this.$refs[product.id][0];

      const primaryUnit = productWrapElement.getElementsByClassName(
        'primary-unit',
      );
      if (!primaryUnit.length) {
        return;
      }

      const primaryUnitInput = primaryUnit[0].getElementsByTagName('input');
      if (!primaryUnitInput.length) {
        return;
      }

      primaryUnitInput[0].focus();
    }
  }

  public onFocusInputUnit(): void {
    this.$emit('focusInputUnit');
  }

  public onBlurInputUnit(): void {
    this.$emit('blurInputUnit');
  }

  public onChangeUnit(unit, item): void {
    item.unidadeMedidasProduto.map((el) => {
      el.digitado = el.id === unit.id;
      return el;
    });
    this.addSendedUnit(unit, item);
    this.unitsCalculate(unit, item);
    this.$emit('changeInputUnit', unit, item);
  }

  public getTotalBySubgroup(produtos: any): string {
    const sum = produtos.reduce((acc, cur) => {
      if (!!cur.unidadeMedidasProduto[0]) {
        const val = cur.unidadeMedidasProduto[0].valor;
        return acc + toNumber(val);
      }
      return acc;
    }, 0);
    return decimalFormat(sum, 2);
  }

  private obsUnitsCalculate$: BehaviorSubject<any> = new BehaviorSubject(null);

  public beforeMount(): void {  
    this.subscribeUnitsCalculate();
  }

  public subscribeUnitsCalculate() {
    this.obsUnitsCalculate$.pipe(
      skipWhile((val) => {
          return val === null;
      }),
      debounce(() => {
        return timer(500);
      }),
      switchMap((payloadMulti) => {
        return service.calcMultiUnitsConversion(payloadMulti).pipe(          
          catchError((err) => {
            this.toast.show('Houve um erro ao calcular a quantidade de produtos', 'error');
            return of(null);
          }),
        );
      })
    ).subscribe(res => {
      if (!res || !res.length) {
        return;
      }
      res.forEach((cm : ConversaoMedidasDTO) => {
        let prod = this.getProductFromGroup(cm.idProduto);
        if (!prod) {
          return;
        }
        let cmDigRes = cm.unidades.filter(m=> m.digitado)[0];
        let unidDigReq = prod.unidadeMedidasProduto.filter(u => u.id == cmDigRes.id)[0];
        // verifica se o valor enviado na request ainda é o mesmo. Se foi atualizado, será utilizado o response posterior atualizado
        if (unidDigReq && decimalFormat(unidDigReq.valor) == decimalFormat(cmDigRes.valor) && unidDigReq.id == cmDigRes.id) {
          this.prepararUniMedidasInsumos(cm.unidades, cm.insumos, prod, unidDigReq);
          this.addConfirmValidarUsoHistProduto(cm);
        }       
      });
      this.validarUsoHistProdutos();
    });
  }

  public addConfirmValidarUsoHistProduto(cm : ConversaoMedidasDTO) {
    if (!cm.usoHistPaciente) {
      return;
    }
    if (!cm.usoHistPaciente.msgUsoHistPaciente) {
      return;
    }
    if (this.idsProdutosUsoHistConfirmados.indexOf(cm.idProduto) != -1) {
      return;
    }
    this.produtosUsoHistConfirmar.set(cm.idProduto, cm);
  }

  public validarUsoHistProdutos() {
    if (!this.produtosUsoHistConfirmar.size) {
      return;
    }
    let prod = Array.from(this.produtosUsoHistConfirmar.values())[0];
    this.produtosUsoHistConfirmar.delete(prod.idProduto);
    setTimeout(() => {
      this.validarUsoHistProduto(prod);
    }, 300);
  }

  public validarUsoHistProduto(cm : ConversaoMedidasDTO) {
    if (!cm.usoHistPaciente) {
      return;
    }
    if (!cm.usoHistPaciente.msgUsoHistPaciente) {
      return;
    }
    let instance = this;
    this.dialog.show(
      'alert',
      cm.nomeProduto,
      cm.usoHistPaciente.msgUsoHistPaciente,
      'Manter produto',
      function() {
        instance.idsProdutosUsoHistConfirmados.push(cm.idProduto);
        instance.validarUsoHistProdutos();
      },
      'Remover produto',
      function() {
        instance.clearProdutoQtde(cm.idProduto);
        instance.validarUsoHistProdutos();
      },
      null,
      '500px'
    );
  }

  public unitsCalculate(unit, product) {
    let volumeFinal = 0;
    let tempoInfusao = 24;

    if (this.item.tempoInfusao !== null && this.isPrescricao) {
      tempoInfusao = this.item.tempoInfusao;
    }
    if (this.item.volumeDesejado !== null) {
      volumeFinal = this.item.volumeDesejado;
    }

    if (!this.item.paciente.peso && this.isPrescricao) {
      return;
    }

    const products = this.getSendedUnits().map((item) => {
      return {
        idProduto: item.product.id,
        unidades: item.product.unidadeMedidasProduto.filter(
          (itemUnit) => !!itemUnit.digitado,
        ),
      };
    });

    if (this.receivedProducts && this.item.isVisualization()) {
      const receivedProd = this.receivedProducts.find(item=> item.id === product.id);
      setTimeout(() => {
        this.addSendedUnit(unit, product)
        this.prepararUniMedidasInsumos(receivedProd.unidades, receivedProd.insumos, product, unit);
      }, 100);
      return;
    }

    let payloadMulti: UnidadesMedidasProdutosPacienteCalcParm = new UnidadesMedidasProdutosPacienteCalcParm();
    payloadMulti.load(this.item);
    if (!payloadMulti.pesoPaciente) {
      return;
    }
    payloadMulti.produtos = [];
    products.forEach(p => {
      let ump: UnidadeMedidaProdCalcParm = new UnidadeMedidaProdCalcParm();
      ump.idProduto = p.idProduto;
      let uniDig = null
      if(p.unidades.filter(u => u.digitado).length) {
        uniDig = p.unidades.filter(u => u.digitado)[0];
      } else {
        return;
      }
      ump.idUnidadeMedida = uniDig.id;
      ump.valor = uniDig.valor ? uniDig.valor : 0;
      payloadMulti.produtos.push(ump);
    });   
    
    payloadMulti.validarUsoHistorico = this.validarUsoHistorico;
    
    this.obsUnitsCalculate$.next(payloadMulti);
  }

  private getProductFromGroup(idProduct): any {
    let prod = null;
    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s=> {
        if (s.produtos.filter(p=> p.id == idProduct).length) {
          prod = s.produtos.filter(p=> p.id == idProduct)[0];
        }
      })
    });
    return prod;
  }

  private prepararUniMedidasInsumos(
    unidades: any,
    insumos: any,
    product: any,
    unit: any,
  ): void {
    product.unidadeMedidasProduto = product.unidadeMedidasProduto.map(
      (itemUnit) => {
        const unitsConversion = unidades.find(
          (item) => item.id === itemUnit.id,
        );
        return {
          ...itemUnit,
          valor: !!unitsConversion
            ? toNumber(decimalFormat(unitsConversion.valor), true)
            : itemUnit.valor,
        };
      },
    );

    product.totalInsumos = insumos.map((material) => {
      material.valor = decimalFormat(material.quantidade);
      return material;
    });

    const value = this.updateProductFromGroup(
      this.groupsList,
      product.id,
      product,
    );

    const clonedValue = cloneDeep(value);
    this.groupsList = this.reorderTypedProducts(clonedValue);

    this.$emit('input', this.groupsList);
    this.$emit('unitsCalculate', unit, product);
  }

  timerRecalcAllUnits: any = null;

  private prepareRecalcAllUnits() {
    clearTimeout(this.timerRecalcAllUnits);
    this.timerRecalcAllUnits = setTimeout(() => {
      this.recalcAllUnits();
    }, 300);
  }

  public recalcAllUnits(filterNeedVolumeTotal: boolean = false): void {
    let items;
    if (filterNeedVolumeTotal) {
      items = this.getSendedUnits().filter((item) => {
        const needVolumeTotal = item.product.unidadeMedidasProduto.some(
          (unit) => unit.nome.toLowerCase() === PARAM_UI_DIA_UNIT,
        );
        return needVolumeTotal;
      });
    } else {
      items = this.getSendedUnits();
    }

    items.forEach(i => {
      this.unitsCalculate(i.unit, i.product);  
    });
  }

  public getSendedUnits(): any[] {
    return this.sendedUnits;
  }

  public addSendedUnit(unit: any, product: any): void {
    const index = this.sendedUnits.findIndex(
      (item) => item.product.id === product.id,
    );

    if (index !== -1) {
      this.sendedUnits.splice(index, 1);
    }

    this.sendedUnits.push({
      unit,
      product,
    });
  }

  public paintTypedUnit(unit): boolean {
    return unit.digitado && (this.item.isVisualization() || !!unit.valor);
  }

  private reorderTypedProducts(groupsList: any[]): any[] {
    const clonedGrouplist = cloneDeep(groupsList);

    /*

    return this.getSendedUnits().reduce((acc, { product }, index) => {
      return this.updateProductFromGroup(clonedGrouplist, product.id, {
        ...product,
        ordemPrescrita: index,
      });
    }, []);
    */
   return clonedGrouplist;
  }

  private updateProductFromGroup(groupsList, productId, payload): any[] {
    const findProductIndex = (subgroup) => {
      return subgroup.produtos.findIndex((product) => {
        return product.id === productId;
      });
    };

    const findSubgroupIndex = (group) => {
      return group.subgrupos.findIndex((subgroup) => {
        return findProductIndex(subgroup) > -1;
      });
    };

    const findGroupIndex = (groups) => {
      return groups.findIndex((group) => {
        return findSubgroupIndex(group) > -1;
      });
    };

    const groupIndex = findGroupIndex(groupsList);
    if (groupIndex > -1) {
      const subgroupIndex = findSubgroupIndex(groupsList[groupIndex]);
      if (subgroupIndex > -1) {
        const productIndex = findProductIndex(
          groupsList[groupIndex].subgrupos[subgroupIndex],
        );
        if (productIndex > -1) {
          groupsList[groupIndex].subgrupos[subgroupIndex].produtos[
            productIndex
          ] = payload;
        }
      }
    }

    return groupsList;
  }

  timerGetGroups: any = null;

  private prepareGetGroups() {
    clearTimeout(this.timerGetGroups);
    this.timerGetGroups = setTimeout(() => {
      this.getGroups();            
    }, 100);
  }

  private getGroups() {
    this.sendedUnits = [];
    this.groupsList = [];
    this.groupsError = false;
    this.idsProdutosUsoHistConfirmados = [];
    this.produtosUsoHistConfirmar = new Map();

    const getUnitClientId = () => {
      if (!!this.item.unidade && !!this.item.unidade.id) {
        return this.item.unidade.id;
      }

      if (this.item.cliente && this.item.cliente.id) {
        return this.item.cliente.id;
      }

      return;
    };

    const getPatientType = () => {
      if (this.isTemplate() && !!this.item.tipoPaciente) {
        return this.item.tipoPaciente;
      }

      if (!!this.item.paciente && !!this.item.paciente.tipo) {
        return this.item.paciente.tipo.id;
      }

      return;
    };

    const unitClientId = getUnitClientId();
    const patientType = getPatientType();

    if (!!patientType &&
    (!this.isPrescricao || (this.isPrescricao && !!unitClientId ))) {
      this.groupsLoading = true;
      let parm = new PrescricaoOpcoesProdutosParmDTO();
      parm.idUnidade = unitClientId;
      parm.tipoPaciente = patientType;
      parm.idPaciente = this.item.paciente.id;
      parm.peso = this.item.paciente.peso;
      parm.template = this.isTemplate();
      let obs = service.getPrescriptionProductsOptions(parm);

      obs.subscribe(
        (data) => {
          const allProducts = [];
          const allGroups = [];
          const allSubgroups = [];
          let groupsList = data;
          groupsList = groupsList.map((group, indexGroup) => {
            allGroups.push({
              index: indexGroup,
              item: group,
            });
            group.subgrupos = group.subgrupos.map((subgroup, indexSubgroup) => {
              allSubgroups.push({
                index: indexSubgroup,
                item: subgroup,
              });
              subgroup.produtos = subgroup.produtos.map(
                (product, indexProduct) => {
                  const newProduct = {
                    ...product,
                  };
                  if (
                    this.item.isEdit() ||
                    this.item.isVisualization() ||
                    this.item.isCopy() ||
                    this.item.isTranscriptionCopy() ||
                    this.item.isModel() ||
                    this.item.isProfile() ||
                    this.item.isPattern()
                  ) {
                    const receivedProd = this.receivedProducts.find(
                      (item) => item.id === newProduct.id,
                    );

                    if (receivedProd) {
                      newProduct.unidadeMedidasProduto = newProduct.unidadeMedidasProduto.map(
                        (unit) => {
                          const typedUnit = receivedProd.unidadeMedidasProduto.find(
                            (receivedUnit) => !!receivedUnit.digitado,
                          );
                          if (!!typedUnit && unit.id === typedUnit.id) {
                            unit.valor = typedUnit.valor;
                            unit.digitado = true;
                          }
                          return unit;
                        },
                      );

                      const foundTypedUnit = newProduct.unidadeMedidasProduto.find(
                        (unit) => unit.digitado,
                      );
                      const typedUnit =
                        foundTypedUnit || newProduct.unidadeMedidasProduto[0];

                      this.onChangeUnit(typedUnit, newProduct);
                    }
                  }
                  allProducts.push({
                    index: indexProduct,
                    item: newProduct,
                  });
                  return newProduct;
                },
              );
              return subgroup;
            });

            return group;
          });

          if (!this.isTemplate()) {
            groupsList = this.setReceivedProducts(
              groupsList,
              allProducts,
              allGroups,
              allSubgroups,
            );
          }
          if (this.item.isVisualization()) {
            groupsList = this.filterEmptyProducts(groupsList);
          }

          groupsList = groupsList.map((group, indexGroup) => {
            group.subgrupos = group.subgrupos.map((subgroup, indexSubgroup) => {
              subgroup.produtos = subgroup.produtos.map(
                (product, indexProduct) => {
                  const newProduct = {
                    ...product,
                    ordem: `${indexGroup}${indexSubgroup}${indexProduct}`,
                  };
                  return newProduct;
                },
              );
              return subgroup;
            });
            return group;
          });

          groupsList = groupsList.sort(sortKey('ordem'));

          groupsList = groupsList.map((group, indexGroup) => {
            group.subgrupos = group.subgrupos.sort(sortKey('ordem'));
            return group;
          });

          this.groupsList = groupsList;
          this.loadTerapia();
          if (this.ocr && this.ocrLoaded) {
            // para casos que ja carregou os valores ocr, porem recarregou a lista de produtos:
            this.loadProdutosOcr(this.ocr);
          }
          this.$emit('input', this.groupsList);
          this.groupsLoading = false;
        },
        () => {
          this.groupsLoading = false;
          this.groupsError = true;
        },
      );
    }
  }

  private setReceivedProducts(
    groupsList,
    allProducts,
    allGroups,
    allSubgroups,
  ): any[] {
    if (
      this.item.isEdit() ||
      this.item.isVisualization() ||
      this.item.isCopy() ||
      this.item.isTranscriptionCopy() ||
      this.item.isModel() ||
      this.item.isProfile() ||
      this.item.isPattern()
    ) {
      this.receivedProducts.map((product) => {
        const productFound = allProducts.find(
          (item) => item.item.id === product.id,
        );
        const newProduct = {
          ...product,
        };

        if (!productFound) {
          const newSubgroup = {
            ...product.subgrupo,
            produtos: [newProduct],
          };
          if (!newSubgroup.id) {
            newSubgroup.id = null;
          }

          const group = {
            ...newSubgroup.grupo,
            subgrupos: [newSubgroup],
          };

          const groupFound = allGroups.find(
            (item) =>
              !!item.item &&
              !!product.subgrupo &&
              product.subgrupo.grupo &&
              item.item.id === product.subgrupo.grupo.id,
          );

          if (!!groupFound) {
            const subgroupFound = allSubgroups.find(
              (item) => item.item.id === product.subgrupo.id,
            );

            if (!!subgroupFound) {
              groupsList[groupFound.index].subgrupos[
                subgroupFound.index
              ].produtos.push(newProduct);
            } else {
              allSubgroups.push({
                index: groupsList[groupFound.index].subgrupos.length,
                item: newSubgroup,
              });
              groupsList[groupFound.index].subgrupos.push(newSubgroup);
            }
          } else {
            allSubgroups.push({
              index: 0,
              item: newSubgroup,
            });
            allGroups.push({
              index: groupsList.length,
              item: group,
            });
            groupsList.push(group);
          }

          this.onChangeUnit(product.unidadeMedidasProduto[0], newProduct);
        }
      });
    }
    return groupsList;
  }

  private filterEmptyProducts(groupsList: any[]): any[] {
    const clonedGroupList = cloneDeep(groupsList);

    return clonedGroupList.reduce((accGroup, group) => {
      group.subgrupos = group.subgrupos.map((subgroup) => {
        subgroup.produtos = subgroup.produtos.filter((product) => {
          const isTyped = product.unidadeMedidasProduto.some(
            (unit) => !!toNumber(unit.valor),
          );
          return isTyped;
        });

        return subgroup;
      });

      group.subgrupos = group.subgrupos.filter(
        (subgroup) => !!subgroup.produtos.length,
      );

      if (!!group.subgrupos.length) {
        accGroup.push(group);
      }

      return accGroup;
    }, []);
  }

  private clearProdutosQtde() {  
    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s=> {
        s.produtos.forEach(p=> {                    
          p.unidadeMedidasProduto.forEach(um=> {
            if (um.digitado) {
              um.valor = 0;
              setTimeout(() => {
                this.onChangeUnit(um, p);                  
              }, 10);
            } 
          })          
        })
      })
    });
  }

  private clearProdutoQtde(idProduto: number) {  
    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s=> {
        s.produtos.filter(p=> p.id == idProduto).forEach(p=> {                    
          p.unidadeMedidasProduto.forEach(um=> {
            if (um.digitado) {
              um.valor = 0;
              setTimeout(() => {
                this.onChangeUnit(um, p);                  
              }, 10);
            } 
          })          
        })
      })
    });
  }

  private loadTerapia() {    
    if (!this.terapiaUso || !this.groupsList || !this.groupsList.length || this.terapiaCarregada) {
      return;
    }
    this.terapiaCarregada = true;

    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s=> {
        s.produtos.forEach(p=> {
          let prodsTerap = this.terapiaUso.produtos.filter(pter => pter.idProduto == p.id);
          if (prodsTerap.length) {
            let prodTerap = prodsTerap[0];
            p.unidadeMedidasProduto.forEach(um=> {
              if (um.id === prodTerap.idUnidadeMedida) {
                um.valor = prodTerap.quantidade;
                um.digitado = true;
                setTimeout(() => {
                  this.onChangeUnit(um, p);                  
                }, 10);
              } else {
                um.digitado = false;
                um.valor = null;
              }
            })
          }
        })
      })
    });
    //this.prepareRecalcAllUnits();    
  }

  private loadProdutosOcr(ocr: TranscricaoOcrResult): void {
    if (!ocr || !this.groupsList || !this.groupsList.length) {
      return;
    }
    let timeout = 0;
    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s=> {
        s.produtos.forEach(p=> {
          let prodsOcr:ProdutoOcrResult[] = ocr.produtos.filter(pter => pter.id == p.id);
          if (prodsOcr.length) {
            let prodOcr = prodsOcr[0];
            p.unidadeMedidasProduto.forEach(um=> {
              if (um.id === prodOcr.idUnidadeMedida) {
                um.valor = String(prodOcr.quantidade).replace(".", ",");
                um.digitado = true;
                setTimeout(() => {
                  this.onChangeUnit(um, p);                  
                }, timeout += 500 );
              } else {
                um.digitado = false;
                um.valor = null;
              }
            })
          }
        })
      })
    });
  }
  private resetEnteral() {
    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s => {
        s.produtos.forEach(p => {                  
          p.medidasEnteralDesc = null;
          p.medidasEnteralSemDesc = null;            
        })
        s.produtos = Object.assign(new Array(), s.produtos);
      })        
    });
  }

  private vincularEnteral() {    
    this.loader.start('Aplicando Enteral...');    
    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s => {
        s.produtos.forEach(p => {            
          let medidas = this.enteralResult.medidas.filter(cm => p.id == cm.idProduto)[0];
          let medidasSemDesc = this.enteralResult.medidasSemDesconto.filter(cm => p.id == cm.idProduto)[0]  
          if (medidas && medidas.unidades) {
            medidas.unidades = Object.assign(new Array(), medidas.unidades).sort((a, b) => {              
              return a.id < b.id ? -1 : 1;
            });   
          }
          p.medidasEnteralDesc = medidas;
          p.medidasEnteralSemDesc = medidasSemDesc;
        })
        s.produtos = Object.assign(new Array(), s.produtos);
      })
    });
    this.loader.stop();
    this.descontarEnteral(false);
  }

  private descontarEnteral(reverter:boolean) {    
    this.groupsList.forEach(g => {
      g.subgrupos.forEach(s=> {
        s.produtos.forEach(p=> {          
          if (!p.medidasEnteralDesc) {
            return;
          }
          p.unidadeMedidasProduto.forEach(u => {
            u.valor = null;
          });
          
          let convMed = p.medidasEnteralDesc.unidades.filter(m => m.digitado)[0];
          let valor = convMed.valor;
          if (reverter && !!convMed.valorEnteral) {
              convMed = p.medidasEnteralSemDesc.unidades.filter(m => m.digitado)[0];
              valor = convMed.valor;
          }
          let ump = p.unidadeMedidasProduto.filter(um=> um.id == convMed.id)[0];
          ump.valor = valor;
          setTimeout(() => {
            this.onChangeUnit(ump, p);            
          }, 10);
        })
      })
    });
    if (!this.enteralResult) {
      this.resetEnteral();
      return;
    }
  }
  
  getStyleByPatientType() {
    if (!this.item || !this.item.paciente || !this.item.paciente.tipo) {
      return '';
    }
    return 'background-color: ' + getPatientType(this.item.paciente.tipo.id).iconColor;
  }

}
